/**
 * A module is one self-contained feature (pages, components, api, locales).
 *
 * defineModule({
 *     id: 'deposit',
 *     requires: ['wallet'],                // other module ids this one depends on
 *     routes: [...],                       // vue-router records
 *     contributes: {                       // items injected into shared extension points
 *         'nav.menu': [{ key, order, label, to, children }],
 *         'home.sections': [{ key, order, component }]
 *     }
 * })
 *
 * Contribution items support:
 *   key       unique within the slot, used by template `slots` ordering
 *   order     ascending sort order (default 100)
 *   auth      true → only for logged-in members
 *   guest     true → only for guests
 *   when      (ctx) => boolean, ctx = { loggedIn, memberInfo }
 */
export function defineModule(config) {
    return {
        requires: [],
        routes: [],
        contributes: {},
        ...config
    };
}

/**
 * A template is a configuration: which modules it uses, its theme, images and
 * the few components it replaces.
 *
 * defineTemplate({
 *     theme: () => import('./theme.scss'),             // required
 *     assets: require.context('./assets/images', ...), // optional image overrides
 *     modules: ['home', 'deposit'],                    // optional allowlist (default: all shared modules)
 *     exclude: ['luckyDraw'],                          // optional blocklist
 *     localModules: [vipModule],                       // modules that only exist in this template
 *     slots: { 'home.sections': ['hotGames'] },        // optional order / subset per extension point
 *     overrides: { TheNav: () => import('./overrides/TheNav.vue') }
 * })
 */
export function defineTemplate(config) {
    return {
        modules: null,
        exclude: [],
        localModules: [],
        slots: {},
        overrides: {},
        assets: null,
        ...config
    };
}
